import { render } from "./InfoIcon.vue?vue&type=template&id=054c318e&ts=true"
import script from "./InfoIcon.ts?vue&type=script&lang=ts"
export * from "./InfoIcon.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__